import request from '@/utils/request'

// 获取运输工具服务历史记录
export function getTransportServiceHistory(params) {
  return request({
    url: '/api/act-service/transportServiceHistoryRecord/list',
    method: 'get',
    params
  })
}

// 保存或更新运输工具服务历史记录
export function saveTransportServiceHistory(data) {
  return request({
    url: '/api/act-service/transportServiceHistoryRecord/saveOrUpdate',
    method: 'post',
    data
  })
}
